

import SecureStorage from 'secure-web-storage'
var CryptoJS = require("crypto-js");

var secureStorage = new SecureStorage(localStorage, {

    hash: function hash(key) {
        var time = localStorage.getItem("loginTime") == null ? "ok" : localStorage.getItem("loginTime").toString()
        key = CryptoJS.SHA256(key, time);

        return key.toString();
    },
    encrypt: function encrypt(data) {
        var time = localStorage.getItem("loginTime") == null ? "ok" : localStorage.getItem("loginTime").toString()
        data = CryptoJS.AES.encrypt(data, time);

        data = data.toString();
        return data;
    },
    decrypt: function decrypt(data) {
        var time = localStorage.getItem("loginTime") == null ? "ok" : localStorage.getItem("loginTime").toString()
        data = CryptoJS.AES.decrypt(data, time);

        data = data.toString(CryptoJS.enc.Utf8);

        return data;
    }
});

export default secureStorage;
